import type { SVGProps } from 'react';

const SvgContentListMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M8.5 6L20 6M8.5 12L20 12M8.5 18L20 18' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
    <path
      d='M5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6Z'
      fill='currentColor'
    />
    <path
      d='M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12Z'
      fill='currentColor'
    />
    <path
      d='M5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgContentListMd;
